module.exports = __webpack_public_path__ + "static/innenFrontLogo-82079dfc2dc56786629975d578cbbae6.jpg";